import { render, staticRenderFns } from "./base.vue?vue&type=template&id=f9c7915c&"
import script from "./base.vue?vue&type=script&lang=ts&"
export * from "./base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports